import { useGetHouseExaminationsQuery } from "@/services/housing";

export const useHouseExaminations = () => {
  const { data: houseExaminationsResponse, ...restHouseExaminationsQuery } =
    useGetHouseExaminationsQuery();
  const houseExaminations = houseExaminationsResponse?.data?.data || {};

  const { enums = {}, ...restHouseExaminations } = houseExaminations;

  return {
    houseExaminations: { ...(restHouseExaminations || {}), ...enums },
    ...restHouseExaminationsQuery,
  };
};
